<div class="main-padding">

  <div class="qb-flex-gb sp-bottom-header">
    <div class="order-details-div" *ngIf="!customerDetailLoading">
      <span class="order-details-subtitle">{{'CUSTOMER_PAGE.NAME' | i18nTranslate}}</span>
      <span class="name customer-name-section max-width-500"
        [matTooltip]="customerDetails['firstName']?customerDetails['firstName']:'----'">{{customerDetails['firstName']
        || '----'}}</span>
    </div>
    <div (click)="closePopup()" class="material-icons clear margin-left-auto">clear</div>
  </div>

  <div class="tabs" *ngIf="!customerDetailLoading">
    <div class="qb-d-flex">
      <div class="tab-label" (click)="tabChange('profile')" [ngClass]="{ active: mainTopic == 'profile' }">
        {{ "CUSTOMER_PAGE.PROFILE" | i18nTranslate }}
      </div>
      <div class="tab-label" (click)="tabChange('membership')" [ngClass]="{ active: mainTopic == 'membership' }">
        {{ "CUSTOMER_PAGE.MEMBERSHIP" | i18nTranslate }}
      </div>
      <div class="tab-label" (click)="tabChange('checkincheckout')"
        [ngClass]="{ active: mainTopic == 'checkincheckout' }">
        {{ "CUSTOMER_PAGE.CHECKIN_CHECKOUT" | i18nTranslate }}
      </div>
    </div>
  </div>


  <div *ngIf="mainTopic === 'profile' && !customerDetailLoading" class="main-tab-content-height main-white-panel">
    <div class="flex-gap-16 height-100" *ngIf="!customerDetailLoading">
      <div class="profile-card">
        <h5 class="qb-container-heading">{{ "CUSTOMER_PAGE.PROFILE_INFORMATION" | i18nTranslate }}</h5>
        <div class="profile-photo">
          <img *ngIf="customerProfilePhoto; else defaultPhoto" [src]="customerProfilePhoto" alt="Profile Photo">
          <ng-template #defaultPhoto>
            <div class="default-photo"></div>
          </ng-template>
        </div>
        <div class="profile-details">

          <div class="detail-row">
            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  mail
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">{{'CUSTOMER_PAGE.EMAIL_ID' | i18nTranslate}}</span>
                <span class="order-details-info"
                  [matTooltip]="customerDetails['emailAddress']?customerDetails['emailAddress']:'----'">{{customerDetails['emailAddress']
                  || '----'}}</span>
              </div>
            </div>

            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  call
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">{{'CUSTOMER_PAGE.PHONE_NUMBER' | i18nTranslate}}</span>
                <span class="order-details-info"
                  [matTooltip]="customerDetails['mobileNumber']?customerDetails['mobileNumber']:'----'">{{customerDetails['mobileNumber']
                  || '----'}}</span>
              </div>
            </div>
          </div>

          <div class="detail-row">
            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  military_tech
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">{{'CUSTOMER_PAGE.SUBSCRIPTION_TIER' | i18nTranslate}}</span>
                <span class="order-details-info"
                  [matTooltip]="customerDetails['subscriptionName']?customerDetails['subscriptionName']:'----'">{{customerDetails['subscriptionName']
                  || '----'}}</span>
              </div>
            </div>

            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  card_membership
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">{{'CUSTOMER_PAGE.STATUS' | i18nTranslate}}</span>
                <span class="order-details-info"
                  [matTooltip]="customerDetails['status']?customerDetails['status']:'----'">{{customerDetails['status']
                  || '----'}}</span>
              </div>
            </div>
          </div>

          <div class="detail-row">
            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  event
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">{{'CUSTOMER_PAGE.START_DATE' | i18nTranslate}}</span>
                <span class="order-details-info"
                  [matTooltip]="customerDetails['subscriptionStartDate']?getDateInFormatForDisplay(customerDetails['subscriptionStartDate']) :'----'">{{
                  getDateInFormatForDisplay(customerDetails['subscriptionStartDate'])
                  || '----'}}</span>
              </div>
            </div>

            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  event
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">{{'CUSTOMER_PAGE.END_DATE' | i18nTranslate}}</span>
                <span class="order-details-info"
                  [matTooltip]="customerDetails['subscriptionEndDate']?getDateInFormatForDisplay(customerDetails['subscriptionEndDate']) :'----'">{{getDateInFormatForDisplay(customerDetails['subscriptionEndDate'])
                  || '----'}}</span>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Profile Photo History Section -->
      <div class="profile-history-card" (scroll)="onScroll()">
        <div class="qb-profile-photo-heading">
          <div>
            <h5 class="qb-container-heading">{{ "CUSTOMER_PAGE.PROFILE_PHOTO_HISOTRY" | i18nTranslate }}</h5>
            <span style="color: rgba(34, 34, 34, 0.6);">{{ "CUSTOMER_PAGE.PREVIOUS_PROFILE_PHOTO" | i18nTranslate
              }}</span>
          </div>
          <span class="material-symbols-outlined">
            history
          </span>
        </div>

        <div class="photo-history">
          <div *ngFor="let photo of customerProfilePhotoHistory">
            <img [src]="photo.urlPath" alt="Previous Profile Photo">
            <span>{{ photo.createdAt | date: 'MMM d, yyyy' }}</span>
          </div>
        </div>

        <div class="empty-history-profile" *ngIf="customerProfilePhotoHistory.length === 0">
          <div class="empty-history-container">
            <span class="material-symbols-outlined empty-history-icon">
              error
            </span>
            <h4 class="empty-history-title"> {{ "CUSTOMER_PAGE.NO_PHOTO_HISTORY" | i18nTranslate }} </h4>
            <p class="empty-history-message"> {{ "CUSTOMER_PAGE.NO_PHOTO_HISTORY_INFO" | i18nTranslate }} </p>
          </div>
        </div>

      </div>
    </div>
  </div>



  <div *ngIf="mainTopic === 'membership'" class="main-tab-content-height main-white-panel">
    <div class="membership-content" *ngIf="!allCustomersListViewDataLoading">
      <div class="qb-membership-row-1">
        <div class="current-membership-card">
          <div class="qb-card-header">
            <h5 class="qb-container-heading">{{ "CUSTOMER_PAGE.CURRENT_MEMBERSHIP" | i18nTranslate }}</h5>
            <span class="status-badge" [class.active]="membershipDetails?.status === 'ACTIVE'">
              {{membershipDetails?.status?.toLowerCase() || 'N/A'}}
            </span>
          </div>
          <div class="membership-details">
            <div class="detail-row-2">
              <span class="label"><mat-icon>military_tech</mat-icon> {{'CUSTOMER_PAGE.SUBSCRIPTION_TIER' |
                i18nTranslate}}</span>
              <span>{{membershipDetails?.subscriptionName || 'N/A'}}</span>
            </div>
            <div class="detail-row-2">
              <span class="label"><mat-icon>calendar_today</mat-icon> {{'CUSTOMER_PAGE.START_DATE' |
                i18nTranslate}}</span>
              <span>{{formatDate(membershipDetails?.subscriptionStartDate)}}</span>
            </div>
            <div class="detail-row-2">
              <span class="label"><mat-icon>event</mat-icon>{{'CUSTOMER_PAGE.END_DATE' | i18nTranslate}}</span>
              <span>{{formatDate(membershipDetails?.subscriptionEndDate)}}</span>
            </div>

            <div class="progress-section">
              <span class="label">{{ "CUSTOMER_PAGE.MEMBERSHIP_PROGRESS" | i18nTranslate }}</span>
              <div class="progress-bar">
                <div class="progress" [style.width]="progressPercentage + '%'"></div>
              </div>
              <span class="days-left">{{daysLeft}} days left</span>
            </div>
          </div>
        </div>

        <div class="membership-actions-card">
          <h5 class="qb-container-heading">{{ "CUSTOMER_PAGE.MEMBERSHIP_ACTIONS" | i18nTranslate }}</h5>
          <div class="action-buttons">
            <button mat-button class="action-btn" (click)="toggleMembershipTierSelection()"
            [disabled]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') || (membershipDetails?.status === 'ACTIVE')" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') :''"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')">
              <span>{{'CUSTOMER_PAGE.ACTIVATE_MEMBERSHIP' | i18nTranslate}} </span>
            </button>
            <button mat-button class="action-btn" 
            [disabled]="(membershipDetails?.status === 'CANCELLED' || membershipDetails?.status === 'INACTIVE') || ('ROLE_READ_ONLY' | checkIfViewOnly:'disable')"
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ''"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
            (click)="openUpgradeMembership()">
             <span>{{'CUSTOMER_PAGE.UPGRADE_MEMBERSHIP' | i18nTranslate}}</span>
            </button>
            <button mat-button class="action-btn" (click)="openCancelConfirmation()"
            [disabled]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') || (membershipDetails?.status === 'CANCELLED')" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ''"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')">
              <span>{{'CUSTOMER_PAGE.CANCEL_MEMBERSHIP' | i18nTranslate}}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Membership Tier Selection -->
      <div class="membership-tier-selection" *ngIf="showTierSelection">
        <h5 class="qb-container-heading">{{isUpgradeMode ? ("CUSTOMER_PAGE.UPGRADE_MEMBERSHIP_TIER" | i18nTranslate) : 
          ("CUSTOMER_PAGE.SELECT_MEMBERSHIP_TIER" | i18nTranslate) }} </h5>
        <div class="tier-cards">
          <div class="tier-card" *ngFor="let tier of membershipTiers" [class.selected]="selectedTierId === tier.id"
          [class.disabled]="isUpgradeMode && !isEligibleForUpgrade(tier)"
            (click)="selectTier(tier.id)">
            <h3>{{tier.tierName}}</h3>
            <div class="tier-price">{{tier.currency}}{{tier.cost}}</div>
            <div class="tier-validity">Valid for {{tier.validityPeriod / 86400}} days</div>
          </div>
        </div>

        <div class="payment-details-container" *ngIf="showPaymentDetails && selectedTierId">
          <h5 class="qb-container-heading">{{ "CUSTOMER_PAGE.PAYMENT_DETAILS" | i18nTranslate }}</h5>
          <div class="payment-form">
            <div class="form-group">
              <label>{{ "CUSTOMER_PAGE.PAYMENT_MODE" | i18nTranslate }}</label>
              <mat-select [(ngModel)]="selectedPaymentMode" required class="matSelect-filters">
                <mat-option value="CREDIT_CARD">Credit Card</mat-option>
                <mat-option value="DEBIT_CARD">Debit Card</mat-option>
                <mat-option value="CASH">Cash</mat-option>
              </mat-select>
            </div>
            <div class="form-group">
              <label>{{ "CUSTOMER_PAGE.SELECT_STORE" | i18nTranslate }}</label>
              <mat-select [(ngModel)]="selectedPaymentStore" required class="matSelect-filters">
                <mat-option *ngFor="let store of storeFilterList" [value]="store">
                  {{store.storeName}}
                </mat-option>
              </mat-select>
            </div>
            <div class="form-group">
              <label>{{ "CUSTOMER_PAGE.REMARKS" | i18nTranslate }}</label>
              <textarea [(ngModel)]="paymentRemarks" cols="20" class="matSelect-filters" style="resize: none;"
              rows="3"></textarea>
            </div>
          </div>
        </div>

        <div class="upgrade-cost" *ngIf="isUpgradeMode && upgradeCost !== null">
          <span>{{ "CUSTOMER_PAGE.EXTRA_COST" | i18nTranslate }} <strong>{{ upgradeCost | customCurrency: revCurrency: true }} </strong></span>
        </div>
        <button mat-button class="confirm-btn" (click)="confirmTierSelection()"
        [disabled]="!selectedTierId || (showPaymentDetails && (!selectedPaymentMode || !selectedPaymentStore.qid))">
          {{ "CUSTOMER_PAGE.CONFIRM" | i18nTranslate }}
        </button>
      </div>

     

      <!-- Membership History -->
      <div class="membership-history-card" >
        <h5 class="qb-container-heading">{{ "CUSTOMER_PAGE.MEMBERSHIP_HISTORY" | i18nTranslate }}</h5>

        <div class="empty-history-membership" *ngIf="membershipHistory.length === 0">
          <div class="empty-history-container">
            <span class="material-symbols-outlined empty-history-icon">
              error
            </span>
            <h4 class="empty-history-title"> {{ "CUSTOMER_PAGE.NO_MEMBERSHIP_HISTORY" | i18nTranslate }}</h4>
            <p class="empty-history-message"></p>
            {{ "CUSTOMER_PAGE.NO_MEMBERSHIP_HISTORY_INFO" | i18nTranslate }}
          </div>
        </div>
        <div class="membership-history-list" *ngIf="membershipHistory.length > 0" (scroll)="onHistoryScroll($event)">
          <div class="history-item" *ngFor="let item of membershipHistory">
            <div class="history-content">
              <h3>{{item.subscriptionName}} Plan</h3>
              <p>{{formatDate(item.subscriptionStartDate)}} - {{formatDate(item.subscriptionEndDate)}}</p>
            </div>
            <span class="status-badge" [class.expired]="item.status === 'INACTIVE'">
              {{item.status}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="mainTopic === 'checkincheckout'" class="main-tab-content-height main-white-panel">
    <div class="qb-checkin-wrapper">
      <div class="qb-checkinout-col-1">
        <div class="visit-statistics-card">
          <h5 class="qb-container-heading">{{ "CUSTOMER_PAGE.MARK_CHECKINOUT" | i18nTranslate }}</h5>
          <div class="statistics-grid">
            <div class="stat-item">
              <span class="stat-label">
                <mat-icon>person</mat-icon>
                {{ "CUSTOMER_PAGE.TODAYS_VISIT" | i18nTranslate }}
              </span>
              <span class="stat-value">{{todayVisits}}</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">
                <mat-icon>groups</mat-icon>
                {{ "CUSTOMER_PAGE.TOTAL_VISITS" | i18nTranslate }}
              </span>
              <span class="stat-value">{{totalVisits}}</span>
            </div>
            <div class="stat-item">
              <span class="stat-label">
                <mat-icon>replay_30</mat-icon>
                {{ "CUSTOMER_PAGE.LAST_30DAYS_VISIT" | i18nTranslate }}
              </span>
              <span class="stat-value">{{last30DaysVisits}}</span>
            </div>
          </div>
          <div *ngIf="storeFilterList.length>1" class="filter-container">
            <div class="filter-title-2">{{'PROFILE_PAGE.SELECT_STORES' | i18nTranslate}}</div>
            <mat-select [(ngModel)]="selectedStore" class="matSelect-filters">
              <mat-option *ngFor="let store of storeFilterList" [value]="store">
                {{store.storeName}}
              </mat-option>
            </mat-select>
          </div>
          <div class="action-buttons-2">
            <button mat-flat-button class="check-in-btn"
            [disabled]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') || ((!selectedStore || !selectedStore.qid))" (click)="markVisit('CHECKIN')" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('')"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" >
              <mat-icon>login</mat-icon>
              {{ "CUSTOMER_PAGE.CHECK_IN" | i18nTranslate }}
            </button>
          </div>
        </div>

        <div class="today-activity-card">
          <h5 class="qb-container-heading">{{ "CUSTOMER_PAGE.TODAYS_ACTIVITY" | i18nTranslate }}</h5>
          <div class="empty-history-todays" *ngIf="todayActivity.length === 0">
            <div class="empty-history-container">
              <span class="material-symbols-outlined empty-history-icon">
                error
              </span>
              <h4 class="empty-history-title">{{ "CUSTOMER_PAGE.NO_CHECKIN_TODAY" | i18nTranslate }}</h4>
              <p class="empty-history-message">{{ "CUSTOMER_PAGE.NO_CHECKIN_TODAY_INFO" | i18nTranslate }}</p>
            </div>
          </div>
          <div class="activity-list">
            <div *ngFor="let activity of todayActivity" class="activity-item"
              [ngClass]="{'latest': activity === todayActivity[0]}">
              <div class="activity-icon">
                <mat-icon *ngIf="activity.type === 'CHECKIN'">login</mat-icon>
                <mat-icon *ngIf="activity.type === 'CHECKOUT'">logout</mat-icon>
              </div>
              <div class="activity-details">
                <span class="activity-type">{{activity.type === 'CHECKIN' ? 'Check-In' : 'Check-Out'}}</span>
                <span class="activity-time">{{formatVisitTime(activity.timestamp)}}</span>
              </div>
              <span *ngIf="activity === todayActivity[0]" class="latest-badge">Latest</span>
            </div>
          </div>
        </div>
      </div>
      <div class="visit-history-card">
        <h5 class="qb-container-heading">{{ "CUSTOMER_PAGE.CHECKIN_OUT_HISTORY" | i18nTranslate }}</h5>

        <div class="empty-history-todays" *ngIf="visitHistory.length === 0">
          <div class="empty-history-container">
            <span class="material-symbols-outlined empty-history-icon">
              error
            </span>
            <h4 class="empty-history-title">{{"CUSTOMER_PAGE.NO_CHECKIN_HISTORY" | i18nTranslate}}</h4>
            <p class="empty-history-message">{{"CUSTOMER_PAGE.NO_CHECKIN_HISTORY_INFO" | i18nTranslate}}</p>
          </div>
        </div>

        <div class="checkin-history-list" (scroll)="onCheckInScroll($event)">
          <div *ngFor="let visit of visitHistory" class="history-item">
            <div class="history-icon"
              [ngClass]="{'checkin': visit.type === 'CHECKIN', 'checkout': visit.type === 'CHECKOUT'}">
              <mat-icon>{{visit.type === 'CHECKIN' ? 'login' : 'logout'}}</mat-icon>
            </div>
            <div class="history-details">
              <span class="history-type">{{visit.type === 'CHECKIN' ? 'Check-In' : 'Check-Out'}}</span>
              <div class="history-time">
                <span class="date">{{formatVisitDate(visit.timestamp)}}</span>
                <span class="time">{{formatVisitTime(visit.timestamp)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div class="activity-spinner-container height-50" *ngIf="allCustomersListViewDataLoading">
    <app-qubriux-loading [size]="35" [loadingText]="'Fetching details...'"></app-qubriux-loading>
  </div>

  <div class="activity-spinner-container height-50" *ngIf="customerDetailLoading">
    <app-qubriux-loading [size]="35" [loadingText]="'Fetching details...'"></app-qubriux-loading>
  </div>
</div>